import styled, { css } from 'styled-components';
import { TContentWidth, TEmptySpaceSide } from './SingleImageWithText';
import { medias } from '@/utils/sizes';
import { Typography } from '@/components/atoms/Typography/Typography.styled';


export const ContentContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['emptySpaceSide'].includes(prop),
})<{
  emptySpaceSide: TEmptySpaceSide;
}>`
  position: relative;
  grid-column-start: ${({ emptySpaceSide }) =>
    emptySpaceSide === 'right' ? 2 : 1};
`;


export const TextSideContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['textPosition'].includes(prop),
})<{
  textPosition: 'top' | 'bottom' | 'center';
}>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ textPosition }) => {
    if (textPosition === 'top') return 'flex-start';
    if (textPosition === 'bottom') return 'flex-end';
    return 'center';
  }};
  grid-row-start: 1;
  gap: var(--spacing-component-inner-lg);
  height: 100%;
  width: 100%;

  ${Typography} {
    margin-top: 0 !important;

    /* ${medias.min.desktopSm} {
      padding-right: 10%;
    } */
  }

  .side-text br {
    display: block;
  }
`;

export const PushtToTopContainer = styled.div`
  margin-top: auto;

  ${medias.max.mobile} {
    display: none;
  }
`;

export const SingleImageContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['imagePosition', 'marginBottom', 'contentWidth'].includes(prop),
})<{
  imagePosition: TEmptySpaceSide;
  marginBottom: string;
  contentWidth: TContentWidth;
}>`
  display: grid;
  margin-bottom: ${({ marginBottom }) => marginBottom};
  width: 100%;
  grid-template-columns: ${({ imagePosition, contentWidth }) => {
    if (imagePosition === 'right') {
      if (contentWidth === '3/2') {
        return '33.3% 66.7%';
      } else if (contentWidth === 'half') {
        return '50% 50%';
      } else {
        return '80.2% 19.8%';
      }
    } else {
      if (contentWidth === '3/2') {
        return '66.7% 33.3%';
      } else if (contentWidth === 'half') {
        return '50% 50%';
      } else {
        return '19.8% 80.2%';
      }
    }
  }};


  ${medias.only.mobile} {
    &:has(${TextSideContainer}) ${ContentContainer} {
      margin-bottom: var(--spacing-component-inner);
    }
  }

  div:empty {
    display: none;
  }

  ${medias.min.desktopSm} {
    &[data-content-width='half'] {
      p {
        padding-right: 10%;
      }
    }
  }

  ${medias.max.tablet} {
    display: flex;
    flex-direction: column;
  }

  ${Typography} {
    margin-top: ${({ marginBottom }) => marginBottom};

    ${medias.max.tablet} {
      width: 100%;
    }
  }

  ${medias.max.tablet} {
    ${TextSideContainer} {
      order: 2;
      margin-top: var(--spacing-component-inner);
    }
  }

  ${medias.max.mobile} {
    row-gap: var(--spacing-component);

    ${TextSideContainer} {
      margin-top: 0;
    }
  }

  img {
    cursor: zoom-in;
  }

  ${medias.min.desktopSm} {
    ${TextSideContainer} {
      grid-row-start: 1;
      box-sizing: border-box;

      ${({ imagePosition }) => css`
        ${imagePosition === 'right' &&
        css`
          padding-right: var(--spacing-component-inner-lg);
          grid-column-start: 1;
        `}
        ${imagePosition === 'left' &&
        css`
          padding-left: var(--spacing-component-inner-xl);
          grid-column-start: 2;
        `}
      `}
    }
  }
`;

